<template>
  <div
    v-if="message"
    class="pa-6 sn-alert"
    :class="`${type}-type`"
  >
    <div class="d-flex">
      <div
        v-if="icon"
        class="mr-4 d-flex flex-column justify-center"
      >
        <v-icon
          :color="iconProps.color"
        >
          {{ iconProps.symbol }}
        </v-icon>
      </div>
      <div class="d-flex flex-column flex-grow-1 justify-center">
        <h4
          v-if="title"
          class="mb-2 sn-font-primary sn-font-weight-bold"
        >
          {{ title }}
        </h4>
        <p class="mb-0 sn-font-primary sn-font-weight-light">
          {{ message }}
        </p>
      </div>
      <div class="ml-4 d-flex flex-column justify-center">
        <div class="d-flex flex-wrap flex-shrink-1 align-center row-gap">
          <sn-btn
            v-if="secondaryText"
            :text="secondaryText"
            size="standard"
            type="text"
            :class="primaryText && secondaryText && 'mr-4'"
            @click="$emit('secondary-click')"
          />
          <sn-btn
            v-if="primaryText"
            :text="primaryText"
            size="standard"
            type="primary"
            @click="$emit('primary-click')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import snBtn from '~/components/snui/v2/snBtn/snBtn'

export default {
  name: 'SnAlert',
  components: { snBtn },
  props: {
    icon: {
      type: Boolean,
      default: true,
      required: false
    },
    message: {
      type: String,
      default: '',
      required: false
    },
    primaryText: {
      type: String,
      default: '',
      required: false
    },
    secondaryText: {
      type: String,
      default: '',
      required: false
    },
    title: {
      type: String,
      default: '',
      required: false
    },
    type: {
      type: String,
      default: 'info',
      required: false,
      validator (type) {
        return !!{
          error: true,
          info: true,
          info2: true,
          success: true,
          warning: true
        }[type]
      }
    }
  },
  computed: {
    iconProps () {
      return {
        error: { symbol: '$snRestricted', color: 'snError03' },
        info: { symbol: '$snInfo', color: 'snPrimary03' },
        info2: { symbol: '$snInfo', color: 'snPrimary03' },
        success: { symbol: '$snCheckCircle', color: 'snSuccess03' },
        warning: { symbol: '$snWarning', color: 'snCaution03' }
      }[this.type]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/css/snui/index.scss';
h4, p {
  font-size: 17px !important;
  line-height: 24px !important;
}
.sn-alert {
  border-radius: 16px;
  border: 1px solid;
}
.row-gap {
  row-gap: 16px;
}
.error-type {
  background-color: $sn-error-01;
  border-color: $sn-error-02 !important;
}
.info-type {
  background-color: $sn-gray-01;
  border-color: $sn-gray-03 !important;
}
.info2-type {
  background-color: $sn-white;
  border-color: $sn-gray-04 !important;
}
.success-type {
  background-color: $sn-success-01;
  border-color: $sn-success-02 !important;
}
.warning-type {
  background-color: $sn-caution-01;
  border-color: $sn-caution-02 !important;
}
</style>
